import { writable } from 'svelte/store';

// Default boilerplates that are always available when starting patdraft
export const DEFAULT_BOILERPLATES = [
    {
        id: 'default-incorporation-by-reference',
        name: 'Incorporation by Reference',
        content: 'All publications, patents, and patent applications mentioned in this specification are herein incorporated by reference in their entirety to the same extent as if each individual publication, patent, or patent application was specifically and individually indicated to be incorporated by reference in its entirety. In the event of a conflict between a term herein and a term in an incorporated reference, the term herein controls.',
        isDefault: true
    },
    {
        id: 'default-definitions',
        name: 'Definitions',
        content: `Unless otherwise defined, all of the technical terms used herein have the same meaning as commonly understood by one of ordinary skill in the art in the field to which this disclosure belongs.

As used in this specification and the appended claims, the singular forms "a," "an," and "the" include plural references unless the context clearly dictates otherwise. Any reference to "or" herein is intended to encompass "and/or" unless otherwise stated.

"About" and "approximately" shall generally mean an acceptable degree of error for the quantity measured given the nature or precision of the measurements. Exemplary degrees of error are within 20 percent (%), typically, within 10%, and more typically, within 5% of a given value or range of values.

As used herein, the terms "comprising" (and any form or variant of comprising, such as "comprise" and "comprises"), "having" (and any form or variant of having, such as "have" and "has"), "including" (and any form or variant of including, such as "includes" and "include"), or "containing" (and any form or variant of containing, such as "contains" and "contain'), are inclusive or open-ended and do not exclude additional, un-recited additives, components, integers, elements, or method steps.

As used herein, ordinal terms such as "first," "second," "third," etc., in the claims to modify a claim element does not by itself connote any priority, precedence, or order of one claim element over another, or the temporal order in which acts of a method are performed, but are used merely as labels to distinguish one claim element having a certain name from another element having a same name (but for use of the ordinal term) to distinguish the claim elements. Similarly, use of a), b), etc., or i), ii), etc. does not by itself connote any priority, precedence, or order of steps in the claims. Similarly, the use of these terms in the specification does not by itself connote any required priority, precedence, or order.`,
        isDefault: true
    },
    {
        id: 'default-specification-boilerplate',
        name: 'Specification Boilerplate',
        content: 'It should be understood from the foregoing that, while particular implementations of the disclosed methods and systems have been illustrated and described, various modifications can be made thereto and are contemplated herein. It is also not intended that the disclosure be limited by the specific examples provided within the specification. While the disclosure has been described with reference to the aforementioned specification, the descriptions and illustrations of the preferable embodiments herein are not meant to be construed in a limiting sense. Furthermore, it shall be understood that all aspects of the disclosure are not limited to the specific depictions, configurations or relative proportions set forth herein which depend upon a variety of conditions and variables. Various modifications in form and detail of the embodiments of the disclosure may be apparent to a person skilled in the art. It is therefore contemplated that the disclosure shall also cover any such modifications, variations and equivalents.',
        isDefault: true
    },
    {
        id: 'default-drawings-intro',
        name: 'Drawings Intro',
        content: `Various aspects of the disclosed methods, devices, and systems are set forth with particularity in the appended claims. A better understanding of the features and advantages of the disclosed methods, devices, and systems will be obtained by reference to the following detailed description of illustrative embodiments and the accompanying drawings, of which:

@{figure:ar_device} provides a diagram for some aspects of an augmented reality system presentation to a user.`,
        isDefault: true
    }
];

export function createBoilerplatesStore() {
    // Initialize with default boilerplates
    const { subscribe, set, update } = writable([...DEFAULT_BOILERPLATES]);

    return {
        subscribe,

        addBoilerplate: (boilerplate) => {
            return update(boilerplates => {
                const newBoilerplate = {
                    ...boilerplate,
                    id: crypto.randomUUID()
                };
                return [...boilerplates, newBoilerplate];
            });
        },

        deleteBoilerplate: (id) => {
            return update(boilerplates => {
                return boilerplates.filter(b => b.id !== id);
            });
        },

        editBoilerplate: (id, updates) => {
            return update(boilerplates => {
                return boilerplates.map(b =>
                    b.id === id ? { ...b, ...updates } : b
                );
            });
        },

        clearBoilerplates: () => {
            // Reset to defaults instead of clearing completely
            set([...DEFAULT_BOILERPLATES]);
        },

        resetToDefaults: () => {
            set([...DEFAULT_BOILERPLATES]);
        }
    };
}

export const boilerplatesStore = createBoilerplatesStore();
